const Header = () => {
    return (
        <header style={{ textAlign: 'center', padding: '20px' }}>
            <img src="/e2-synergy-logo.png" alt="E2 Synergy Logo" style={{ maxWidth: '100px' }} />
            <h1>E2 Synergy</h1>
        </header>
    );
};

export default Header;